var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { alloy } from '../colors';
export default class Circle extends PureComponent {
    render() {
        const _a = this.props, { width, className, color, outline, outlineWidth } = _a, rest = __rest(_a, ["width", "className", "color", "outline", "outlineWidth"]);
        return (React.createElement("svg", Object.assign({ className: className, fill: color, stroke: outline, strokeWidth: outlineWidth, width: width, height: width, viewBox: "0 0 18 18" }, rest),
            React.createElement("circle", { cx: "9", cy: "9", r: "8" })));
    }
}
Circle.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
    outline: PropTypes.string,
    width: PropTypes.number,
    outlineWidth: PropTypes.string,
};
Circle.defaultProps = {
    color: '',
    outline: alloy,
    className: 'default',
    width: 14,
    outlineWidth: '1px',
};
